import { render, staticRenderFns } from "./externals.vue?vue&type=template&id=f3c2a2a2"
import script from "./externals.vue?vue&type=script&lang=js"
export * from "./externals.vue?vue&type=script&lang=js"
import style0 from "./externals.vue?vue&type=style&index=0&id=f3c2a2a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports